import React, { useState } from 'react';

import { makeStyles } from '../library';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Paper,
    SimpleDraggable as Draggable,
    Typography,
    IconButton,
    Grid,
    TextField
} from '../library';

import * as icons from '../icons';

const useStyles = makeStyles(theme => ({
    wrapper: {
        display: 'flex',
        width: '100%',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'flex-start',
        '&>*': {
            marginRight: theme.spacing(2)
        }
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[20],
        padding: theme.spacing(2, 4, 3)
    }
}));

const PaperComponent = props => {
    return (
        <Draggable
            handle='#draggable-dialog-title'
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
};

const Parameters = props => {
    const { title, ok, open, close, maxWidth, parameters } = props;
    const classes = useStyles('red');

    const [values, setValues] = useState(() => {
        const initialStates = {};
        Object.keys(parameters).forEach(key => {
            if (parameters[key].type) {
                initialStates[key] = parameters[key].value;
            }
        });
        return initialStates;
    });

    const handleChange = event => {
        setValues({
            ...values,
            [event.target.name]: event.target.value
        });
    };

    if (!open) return null;

    return (
        <Dialog
            open={open}
            PaperComponent={PaperComponent}
            aria-labelledby='draggable-dialog-title'
            fullWidth={true}
            maxWidth={maxWidth ? maxWidth : 'md'}
        >
            <DialogTitle style={{ cursor: 'move' }} id='draggable-dialog-title'>
                <div className={classes.wrapper}>
                    <Typography variant='h4'>{title}</Typography>
                    {ok ? (
                        <IconButton size='small' onClick={() => ok(values)}>
                            <icons.OkIcon />
                        </IconButton>
                    ) : null}
                    {close ? (
                        <IconButton size='small' onClick={close}>
                            <icons.CloseIcon />
                        </IconButton>
                    ) : null}
                </div>
            </DialogTitle>
            <DialogContent className={classes.paper}>
                <Grid container spacing={3} sx={{ padding: 2 }}>
                    {Object.keys(parameters).map(key => {
                        if (!parameters[key].type) {
                            return null;
                        }
                        return (
                            <Grid item key={key}>
                                <TextField
                                    size={'small'}
                                    fullWidth
                                    name={key}
                                    label={parameters[key].label}
                                    value={values[key]}
                                    type={parameters[key].type}
                                    onChange={handleChange}
                                />
                            </Grid>
                        );
                    })}
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default Parameters;
